import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * Hook to create language-aware links
 * @returns Function that prefixes paths with current language
 */
export function useLanguageLink() {
  const { lang } = useParams<{ lang: string }>();
  const { i18n } = useTranslation();

  // Use URL param language, fallback to i18n language, fallback to 'en'
  const currentLang = lang || i18n.language || 'en';

  /**
   * Creates a language-aware path
   * @param path - The path without language prefix (e.g., "/pricing")
   * @returns The path with language prefix (e.g., "/en/pricing")
   */
  const createLink = (path: string): string => {
    // Remove leading slash if present
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    return `/${currentLang}/${cleanPath}`;
  };

  return { createLink, currentLang };
}
